export const MARK_ALT_DEAL_STRUCTURES_STALE = 'MARK_ALT_DEAL_STRUCTURES_STALE';
export const MARK_ALT_DEAL_STRUCTURES_FRESH = 'MARK_ALT_DEAL_STRUCTURES_FRESH';
export const ALT_DEAL_STRUCTURE_CELL_SELECTED = 'ALT_DEAL_STRUCTURE_CELL_SELECTED';
export const ALT_DEAL_STRUCTURE_CELL_DESELECTED = 'ALT_DEAL_STRUCTURE_CELL_DESELECTED';
export const ALT_DEAL_STRUCTURE_SCENARIO_CREATED = 'ALT_DEAL_STRUCTURE_SCENARIO_CREATED';
